import type { GatsbyBrowser } from "gatsby"
import { default as ionosTheme } from "@onestore/hel/dist/theme/ionos"
import { wrapPageElementWithTheme } from "../../src/wrappers/ssr"
import "./styles.css"

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] =
  wrapPageElementWithTheme("ionos", ionosTheme)
